import {Card, Col, Divider, Row, Table} from 'antd';
import * as PropTypes from 'prop-types';
import {selectAuth} from '../../../redux/selectors';
import {connect} from 'react-redux';
import React from 'react';
import {RQGetCampaignDashboardEnrollments} from '../../../reactQuery/apis/rqCampaignDashboardAPI';
import EnrollmentTableColumns from './EnrollmentTableColumns';
import {RQGetCustomerMasterReport} from '../../../reactQuery/apis/rqCustomerCampaignEnrollAPI';
import {toYearMonth} from '../../../utils/DateUtils';
import PaymentTableColumns from './PaymentTableColumns';

const CampaignDashboardScreen = ({auth})=> {
  //RQGetCampaignDashboardEnrollments

  const {
    data:enrollments = [],
  } = RQGetCampaignDashboardEnrollments({
    token: auth?.token,
    filter: {},
    locationId: auth?.employee?.location?.id,
  });

  const {
    data:masterReport = [],
  } = RQGetCustomerMasterReport({
    token: auth?.token,
    filter: {locationId: auth?.employee?.location?.id, yearMonth: toYearMonth(Date())},
  });

  return(
    <Card>
      <Divider orientation={'left'}>Dashboard</Divider>
      <Row gutter={[24]}>
        <Col span={12}>
          <Table dataSource={enrollments} columns={EnrollmentTableColumns()} pagination={false}
            title={()=> 'Enrollments By Month'}
            bordered={true} />
        </Col>
        <Col span={12}>
          <Table dataSource={masterReport} columns={PaymentTableColumns()} pagination={false}
            title={()=> 'Payment History'}
            bordered={true} />
        </Col>
      </Row>
    </Card>
  );
};

CampaignDashboardScreen.propTypes = {
  auth: PropTypes.any,
  menuClicked: PropTypes.bool,
  onClick: PropTypes.func,
  setMenuClicked: PropTypes.func,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(CampaignDashboardScreen);
